import Axios from 'axios';
import React from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import ReactTable from 'react-table';

export const NewAttachment = (props) => {
  const [visible, setVisible] = React.useState(false);
  const [files, setFiles] = React.useState([]);
  const [submitting, setSubmitting] = React.useState(false);

  const fileColumns = [
    {
      Header: 'Filename',
      accessor: 'name',
    },
    {
      Header: '',
      maxWidth: 70,
      Cell: (rowdata) => {
        return (
          <a
            onClick={() => {
              files.splice(rowdata.index, 1);
              setFiles(files);
            }}
            href='#/'
            className='link text-info'>
            Delete
          </a>
        );
      },
    },
  ];

  const handleFileAdd = (event: any) => {
    setFiles([...files, event.target.files[0]]);
  };

  const handleClose = () => {
    setFiles([]);
    setVisible(false);
  };

  const onSubmit = async () => {
    setSubmitting(true);
    const formData = new FormData();
    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        formData.append('files', files[i]);
      }
    }
    try {
      await Axios.post(`${(window as any)._env_.REACT_APP_SERVER}/request/addAttachment`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        params: {
          requestId: props.requestId,
        },
      })
        .then((res) => {
          if (res?.data?.status == 200) {
            alert('Files Uploaded Successfully');
          }
          console.log('res: ', JSON.stringify(res));
          setSubmitting(false);
          handleClose();
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch((err) => {
          // The backend returns { status: 400, errors: JSON.stringify(errorFiles) }
          // where errorFiles is an array of { error, file } for each failed upload.
          let message = 'Error Uploading Files:';
          const rawErrors = err?.response?.data?.errors;
          if (rawErrors) {
            try {
              const errorFiles: { error: string; file: string }[] = JSON.parse(rawErrors);
              if (Array.isArray(errorFiles) && errorFiles.length > 0) {
                const fileList = errorFiles
                  // The backend stores the condensed S3 key (filename.ext_--_uuid);
                  // strip the _--_uuid suffix to show the original filename.
                  .map((ef) => `• ${decodeURIComponent(String(ef.file).split('_--_')[0])} (${ef.error})`)
                  .join('\n');
                message = `The following files failed to upload:\n\n${fileList}`;
              }
            } catch (parseErr) {
              console.log('Error parsing errorFiles: ', parseErr);
            }
          }
          alert(message);
          setSubmitting(false);
          handleClose();
          console.log('Error: /frontend/src/components/RequestForms/components/NewAttachment//onSubmit', err);
        });
    } catch (e) {
      alert(`Error Uploading Files: ${e}`);
      setSubmitting(false);
      handleClose();
    }
  };

  return (
    <div>
      <Button onClick={() => setVisible(true)} variant='danger'>
        Upload New Attachments&nbsp; {<i className='fa fa-upload' />}
      </Button>
      <Modal dialogClassName='modal-half-width' show={visible} onHide={() => setVisible(false)}>
        <Modal.Header>
          <Modal.Title>Upload New Attachments</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form id='form'>
            <div className='row justify-content-start m-1'>
              <div className='form-group'>
                <label>Attachments&nbsp;&nbsp;</label>
                <input type='file' name='attachments' onChange={(e) => handleFileAdd(e)} />
              </div>
            </div>
            {files.length !== 0 && (
              <div className='row justify-content-start mb-4'>
                <div className='col-sm'>
                  <ReactTable showPagination={false} columns={fileColumns} data={files} pageSize={files.length} NoDataComponent={() => null} />
                </div>
              </div>
            )}
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='info' form='form' disabled={files.length < 1} onClick={() => onSubmit()}>
            {submitting && <Spinner className='mr-1' as='span' animation='border' size='sm' role='status' aria-hidden='true' />}
            Upload
          </Button>
          <Button onClick={handleClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
